import * as client_hooks from '../../../src/hooks.client.js';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173')
];

export const server_loads = [];

export const dictionary = {
		"/(app)/agent": [13,[2,3]],
		"/(app)/agent/agents": [14,[2,3]],
		"/(app)/agent/automation": [15,[2,3]],
		"/(app)/agent/create": [16,[2,3]],
		"/(app)/agent/studio": [17,[2,3]],
		"/(app)/analytics": [18,[2]],
		"/(app)/api-keys": [19,[2]],
		"/(app)/billing": [20,[2]],
		"/[[lang=locale]]/blog/[[page=pageNumber]]": [68,[8,9]],
		"/[[lang=locale]]/blog/[slug]": [69,[8,9]],
		"/(app)/chat": [21,[2,4]],
		"/(app)/collections": [22,[2]],
		"/(app)/collections/[id]": [23,[2]],
		"/(app)/dashboard": [24,[2]],
		"/dashboard/agent": [90],
		"/dashboard/agent/agents": [91],
		"/dashboard/agent/automation": [92],
		"/dashboard/agent/create": [93],
		"/dashboard/agent/studio": [94],
		"/dashboard/analytics": [95],
		"/dashboard/api": [96],
		"/dashboard/billing": [97],
		"/dashboard/chat": [98],
		"/dashboard/collections": [99],
		"/dashboard/collections/[id]": [100],
		"/dashboard/employees": [101],
		"/dashboard/employees/departments": [102],
		"/dashboard/employees/hire": [103],
		"/dashboard/employees/workforce": [104],
		"/dashboard/gamification": [105],
		"/dashboard/matrix": [106],
		"/dashboard/matrix/category/[slug]": [109],
		"/dashboard/matrix/[id]": [107],
		"/dashboard/matrix/[id]/run": [108],
		"/dashboard/my-modules": [110],
		"/dashboard/organization": [111],
		"/dashboard/pipelines": [112],
		"/dashboard/pipelines/[id]": [113],
		"/dashboard/search": [114],
		"/dashboard/settings": [115],
		"/dashboard/subscription-management": [117],
		"/dashboard/subscription-plans": [118],
		"/dashboard/subscription": [116],
		"/dashboard/support": [119],
		"/dashboard/team": [120],
		"/dashboard/tickets": [121],
		"/dashboard/tickets/[id]": [122],
		"/dashboard/tools": [123],
		"/dashboard/tools/[id]": [124],
		"/dashboard/workspace": [125],
		"/dashboard/workspace/artifacts": [126],
		"/dashboard/workspace/knowledge": [127],
		"/dashboard/workspace/knowledge/[id]": [128],
		"/dashboard/workspace/models": [129],
		"/dashboard/workspace/models/edit": [130],
		"/dashboard/workspace/models/new": [131],
		"/dashboard/workspace/pipelines": [132],
		"/dashboard/workspace/pipelines/[id]": [133],
		"/dashboard/workspace/prompts": [134],
		"/dashboard/workspace/tools": [135],
		"/dashboard/workspace/tools/[id]": [136],
		"/employees": [137],
		"/employees/departments": [138],
		"/employees/hire": [139],
		"/employees/workforce": [140],
		"/(app)/employee": [25,[2,5]],
		"/(app)/employee/departments": [26,[2,5]],
		"/(app)/employee/hire": [27,[2,5]],
		"/(app)/employee/workforce": [28,[2,5]],
		"/[[lang=locale]]/forgot-password": [70,[8]],
		"/(app)/gamification": [29,[2]],
		"/[[lang=locale]]/login": [71,[8]],
		"/(app)/marketplace": [30,[2]],
		"/[[lang=locale]]/matrix": [72,[8,10]],
		"/[[lang=locale]]/matrix/category/[slug]": [75,[8,10]],
		"/[[lang=locale]]/matrix/[id]": [73,[8,10]],
		"/[[lang=locale]]/matrix/[id]/run": [74,[8,10]],
		"/modules": [141],
		"/modules/category/[slug]": [144],
		"/modules/[id]": [142],
		"/modules/[id]/run": [143],
		"/(app)/my-modules": [31,[2]],
		"/[[lang=locale]]/news/[[page=pageNumber]]": [76,[8,11]],
		"/[[lang=locale]]/news/[slug]": [77,[8,11]],
		"/(app)/organization": [32,[2,6]],
		"/(app)/organization/create": [33,[2,6]],
		"/(app)/organization/invitations": [34,[2,6]],
		"/(app)/organization/members": [35,[2,6]],
		"/(app)/organization/overview": [36,[2,6]],
		"/(app)/organization/settings": [37,[2,6]],
		"/(app)/organization/structure": [38,[2,6]],
		"/[[lang=locale]]/pages/[slug]": [78,[8]],
		"/payment": [145],
		"/payment/callback": [146],
		"/payment/failure": [147],
		"/payment/plan/[planId]": [148],
		"/payment/subscribe/[planId]": [149],
		"/payment/success": [150],
		"/(app)/pipelines": [39,[2]],
		"/(app)/pipelines/[id]": [40,[2]],
		"/[[lang=locale]]/pipeline": [79,[8,12]],
		"/[[lang=locale]]/pricing": [80,[8]],
		"/[[lang=locale]]/pricing/enterprise": [81,[8]],
		"/[[lang=locale]]/reset-password": [82,[8]],
		"/(app)/search": [41,[2]],
		"/(app)/settings": [42,[2]],
		"/[[lang=locale]]/signup": [83,[8]],
		"/[[lang=locale]]/solutions": [84,[8]],
		"/[[lang=locale]]/solutions/ai-agents": [85,[8]],
		"/[[lang=locale]]/solutions/ai-employees": [86,[8]],
		"/[[lang=locale]]/solutions/enterprise-ai": [87,[8]],
		"/[[lang=locale]]/solutions/enterprise-rag": [88,[8]],
		"/[[lang=locale]]/solutions/on-premise": [89,[8]],
		"/store": [151],
		"/store/category/[category]": [153],
		"/store/[moduleId]": [152],
		"/(app)/subscription-management": [44,[2]],
		"/(app)/subscription-plans": [45,[2]],
		"/(app)/subscription": [43,[2]],
		"/(app)/support": [46,[2]],
		"/(app)/team": [47,[2]],
		"/(app)/tickets": [48,[2]],
		"/(app)/tickets/[id]": [49,[2]],
		"/(app)/tools": [50,[2]],
		"/(app)/tools/[id]": [51,[2]],
		"/(app)/workspace": [52,[2,7]],
		"/workspace/artifacts": [154],
		"/workspace/artifacts/edit": [156],
		"/workspace/artifacts/new": [157],
		"/workspace/artifacts/[id]": [155],
		"/(app)/workspace/artifact": [53,[2,7]],
		"/(app)/workspace/knowledge": [54,[2,7]],
		"/(app)/workspace/knowledge/[id]": [55,[2,7]],
		"/workspace/models": [158],
		"/workspace/models/edit": [160],
		"/workspace/models/new": [161],
		"/workspace/models/[id]": [159],
		"/(app)/workspace/model": [56,[2,7]],
		"/(app)/workspace/model/edit": [57,[2,7]],
		"/(app)/workspace/model/new": [58,[2,7]],
		"/workspace/pipelines": [162],
		"/workspace/pipelines/edit": [164],
		"/workspace/pipelines/new": [165],
		"/workspace/pipelines/[id]": [163],
		"/(app)/workspace/pipeline": [59,[2,7]],
		"/(app)/workspace/pipeline/edit": [61,[2,7]],
		"/(app)/workspace/pipeline/new": [62,[2,7]],
		"/(app)/workspace/pipeline/[id]": [60,[2,7]],
		"/workspace/prompts": [166],
		"/workspace/prompts/edit": [168],
		"/workspace/prompts/new": [169],
		"/workspace/prompts/[id]": [167],
		"/(app)/workspace/prompt": [63,[2,7]],
		"/workspace/tools": [170],
		"/workspace/tools/edit": [172],
		"/workspace/tools/new": [173],
		"/workspace/tools/[id]": [171],
		"/(app)/workspace/tool": [64,[2,7]],
		"/(app)/workspace/tool/[id]": [65,[2,7]],
		"/[[lang=locale]]": [66,[8]],
		"/[[lang=locale]]/[slug]": [67,[8]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';